import config from "@/config";
import http from "@/utils/request";

export default {
	token: {
		url: `${config.API_URL}/Login`,
		name: "登录获取TOKEN",
		get: async function (data = {}) {
			//debugger
			let result = await http.get(this.url, data);
			return result;
		},
	},
	objProcess: {
		url: `${config.API_URL}/objProcess`,
		post: async function (data, config = {}) {
			//////debugger
			//return await http.post(this.url, data, config);
			return await http.post(this.url, data, config);
		},
	},
	GetProcessApi: {
		get: async function (ApiName, data) {
			return await http.get(`${config.API_URL}/` + ApiName, data);
		},
	},
	PostProcessApi: {
		post: async function (ApiName, data, config = {}) {
			return await http.get(this.url + ApiName, data, config);
		},
	},
	downFile: {
		url: `${config.API_URL}/DownloadFile`,
		get: async function (file) {
			debugger;
			//return await http.post(this.url, data, config);
			return await http.get(this.url, { fielName: file });
		},
	},
};
